import { render } from "./StylePicker.vue?vue&type=template&id=5df01c8a&scoped=true"
import script from "./StylePicker.vue?vue&type=script&lang=js"
export * from "./StylePicker.vue?vue&type=script&lang=js"

import "./StylePicker.vue?vue&type=style&index=0&id=5df01c8a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5df01c8a"]])

export default __exports__